<div class="main-wrapper">
    <div class="modal-body">
        <button type="button" class="close" (click)="hideModal()">
            <span>×</span><span class="sr-only">Close</span>
        </button>

        <div class="row m-b-sm increased-text">
            <div class="col-sm-12">
                    The symbols `*` or `~` can help you effectively search the recipient list:<br><br>

                    Use '*' in the end of your search string to search everything that starts with your search string.<br><br>

                    Example: 2* will give you all units starting with the number 2.<br><br>

                    Use `~` to define search string length.<br><br>

                    Example: 2~~ would list units that consist of 3 digits starting with 2 (200-299) but not 2000-2999<br><br>

                    DO NOT USE BOTH `*` AND `~` IN THE SAME SEARCH
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/email/search-instructions-modal/search-instructions-modal.component.html